import handleEventMap from '../common/handleEventMap';
import handleMultiSelection from './handleMultiSelection';

/**
 * Returns a callback that performs a selection on a select
 * component that allows multiple selections at a time and
 * triggers the custom select:change event.
 * @param select
 * @returns {Function}
 */
const handleMultiSelectChange = (select) => (e) => {
    handleMultiSelection(select)(e);
    handleEventMap(select, 'select:change')(e);
};

export default handleMultiSelectChange;



// WEBPACK FOOTER //
// ./src/scripts/components/select/handleMultiSelectChange.js